/**
 * Typed view over analytics.config.json — the ONE owner of non-secret analytics
 * config (ADR 0027 §4). Bash reads the JSON with jq, terraform with
 * jsondecode(file(...)), skills cite the path. Add a value here, never inline it.
 *
 * posthog.projectIds — per-environment projects (ADR 0012): production is
 *   104056 (also carries pre-split history), staging 247434, development 247433.
 * posthog.hosts.capture — the ingest host SDKs post to (`eu.i.` = ingest);
 *   posthog.hosts.ui — the app host for dashboard/insight URLs.
 * posthog.internalStaffCohortId — the "internal" cohort every product-surface
 *   query excludes (posthog-query skill §Universal filters).
 * sentry.org / sentry.projects.app — slugs used by app.config.js and
 *   scripts/rotate-sentry-token.sh.
 */
import config from './analytics.config.json';
// The JSON is the only value source; freezing stops a consumer mutating the shared object.
export const ANALYTICS_CONFIG = Object.freeze(config);
export const POSTHOG_HOSTS = Object.freeze(config.posthog.hosts);
export const POSTHOG_PROJECT_IDS = Object.freeze(config.posthog.projectIds);
export const INTERNAL_STAFF_COHORT_ID = config.posthog.internalStaffCohortId;
export const SENTRY_ORG = config.sentry.org;
export const SENTRY_PROJECTS = Object.freeze(config.sentry.projects);
export function posthogProjectIdFor(env) {
    return POSTHOG_PROJECT_IDS[env];
}
